export default __webpack_public_path__ + "static/media/skypond.dd9c969b.jpg";